import { pumaAPI, dataAPI } from "./api"
import { ReceiveNothing } from "./api/base"
import { Bookmark } from "../models"
import { BookmarkDTO, IDataAPIBookmarkDTO } from "./models/dto/bookmark"
import {
    PumaPaginatedResponse,
    PumaParsedPaginatedResponse,
} from "./models/api/puma"

export const getBookmarks = (
    workspaceId: number | null,
    filter?: string,
): Promise<PumaParsedPaginatedResponse<Bookmark>> =>
    pumaAPI
        .getJSON("Bookmarks", { filter, workspaceId })
        .then((bookmarks: PumaPaginatedResponse<BookmarkDTO>) => ({
            paging: {
                pageSize: bookmarks.Paging.PageSize,
                totalRecordCount: bookmarks.Paging.TotalRecordCount,
            },
            data: bookmarks.Data.$values.map((bookmark: BookmarkDTO) => ({
                bookmarkId: bookmark.BookmarkId,
                bookmarkUrl: bookmark.BookmarkUrl,
                personId: bookmark.PersonId,
                resourceId: bookmark.ResourceId,
                resourceType: bookmark.ResourceType,
                sequenceNr: bookmark.SequenceNr,
                title: bookmark.Title,
                workspaceId: bookmark.WorkspaceId,
                workspaceScreenLabel: bookmark.WorkspaceScreenLabel,
                icon: bookmark.Icon,
            })),
        }))

export const addBookmark = (
    resourceType: string,
    resourceId: number,
    resourceUrl: string,
    workspaceId: number | null,
    parentItemId?: number | null,
): Promise<number> =>
    pumaAPI
        .postJSON(`Bookmarks/${resourceType}`, {
            ResourceId: resourceId,
            ResourceUrl: resourceUrl,
            ParentId: parentItemId,
            WorkspaceId: workspaceId,
        })
        .then((bookmark: BookmarkDTO) => bookmark.BookmarkId)

export const findBookmark = (
    resourceType: string,
    resourceId: number,
    parentItemId?: number | null,
): Promise<number | void> =>
    pumaAPI
        .postJSON(`Bookmarks/${resourceType}/FindBookmark`, {
            ResourceId: resourceId,
            ParentId: parentItemId,
        })
        .then((bookmark: BookmarkDTO) => bookmark.BookmarkId)

export const removeBookmark = (bookmarkId: number): Promise<void> =>
    pumaAPI.remove(`Bookmarks/${bookmarkId}`)

export const saveBookmarkTitle = (
    bookmarkId: number,
    title: string,
): Promise<void> =>
    pumaAPI.putJSON(`Bookmarks/${bookmarkId}/title`, { title }, ReceiveNothing)

/**
 * uses data API to save bookmark
 * @param resourceType
 * @param resourceId
 * @returns
 */
export const addBookmarkUsingDataApi = async (
    resourceType: string,
    resourceId: number,
): Promise<number> => {
    const data: IDataAPIBookmarkDTO = await dataAPI.postJSON("Bookmarks", {
        "@odata.type": `#TF.${resourceType}Bookmark`,
        Resource: {
            "@odata.type": `#TF.${resourceType}`,
            Id: resourceId,
        },
    })
    return data.Id
}

/**
 * uses data API for removing bookmark
 * @param bookmarkId
 */
export const removeBookmarkUsingDataApi = async (
    bookmarkId: number,
): Promise<void> => {
    await dataAPI.remove(`Bookmarks/${bookmarkId}`)
}

/**
 * uses data api to find bookmark
 * @param resourceType
 * @param resourceId
 * @returns
 */
export const findBookmarkUsingDataApi = async (
    resourceType: string,
    resourceId: number,
): Promise<number | null> => {
    const bookmark: IDataAPIBookmarkDTO = await dataAPI.getJSON(
        `${resourceType}s/${resourceId}/GetBookmark()`,
    )
    return bookmark.Id ? bookmark.Id : null
}
